import { Component, OnInit, Input, EventEmitter, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { CurriculumService } from 'src/app/Services/curriculum.service';
import { IServiceFactory } from 'src/app/Services/service-factory';

@Component({
  selector: 'app-curriculum-register-parent-password',
  templateUrl: './curriculum-register-parent-password.component.html',
  styleUrls: ['./curriculum-register-parent-password.component.scss']
})
export class CurriculumRegisterParentPasswordComponent implements OnInit {
  service: CurriculumService;

  passwordWait: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<CurriculumRegisterParentPasswordComponent>,
    private serviceFactory: IServiceFactory,
    private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data
    ) {}

  ngOnInit(): void {
    this.service = this.serviceFactory.getCurriculumService()
  }

  password: string = null;

  valueUpdated = new EventEmitter<string>();
  
  onCancel(){
    this.valueUpdated.emit(null);
    this.dialogRef.close();
  }

  onSubmit(){
    if (!this.password){
      this.toastr.warning('Please enter a password', 'Warning!');
    }
    if(this.passwordWait){
      return;
    }

    this.passwordWait = true;

    this.service.ValidateParentPassword(this.password).subscribe((result) => {
      if (!result){
        this.toastr.warning('Password invalid', 'Warning!');

      } else {
        this.valueUpdated.emit(this.password);
        this.dialogRef.close();
      }
      this.passwordWait = false;
    });
  }

  EnterSubmit($event){
    if($event.keyCode === 13){
      this.onSubmit();
    }
  }

}
